import { render, staticRenderFns } from "./InventoryParamSetting.vue?vue&type=template&id=63cc6b87&scoped=true"
import script from "./InventoryParamSetting.vue?vue&type=script&lang=ts"
export * from "./InventoryParamSetting.vue?vue&type=script&lang=ts"
import style0 from "./InventoryParamSetting.vue?vue&type=style&index=0&id=63cc6b87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc6b87",
  null
  
)

export default component.exports